import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './globally-free-subscription-plan.reducer';
import { IGloballyFreeSubscriptionPlan } from 'app/shared/model/globally-free-subscription-plan.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IGloballyFreeSubscriptionPlanUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const GloballyFreeSubscriptionPlanUpdate = (props: IGloballyFreeSubscriptionPlanUpdateProps) => {
  const [updatedById, setUpdatedById] = useState('0');
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { globallyFreeSubscriptionPlanEntity, users, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/globally-free-subscription-plan');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }

    props.getUsers();
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...globallyFreeSubscriptionPlanEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.globallyFreeSubscriptionPlan.home.createOrEditLabel">Create or edit a GloballyFreeSubscriptionPlan</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : globallyFreeSubscriptionPlanEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="globally-free-subscription-plan-id">ID</Label>
                  <AvInput id="globally-free-subscription-plan-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup check>
                <Label id="isFreeSubscriptionPlanLabel">
                  <AvInput
                    id="globally-free-subscription-plan-isFreeSubscriptionPlan"
                    type="checkbox"
                    className="form-check-input"
                    name="isFreeSubscriptionPlan"
                  />
                  Is Free Subscription Plan
                </Label>
              </AvGroup>
              <AvGroup>
                <Label id="updatedOnLabel" for="globally-free-subscription-plan-updatedOn">
                  Updated On
                </Label>
                <AvField id="globally-free-subscription-plan-updatedOn" type="date" className="form-control" name="updatedOn" />
              </AvGroup>
              <AvGroup>
                <Label for="globally-free-subscription-plan-updatedBy">Updated By</Label>
                <AvInput id="globally-free-subscription-plan-updatedBy" type="select" className="form-control" name="updatedBy.id">
                  <option value="" key="0" />
                  {users
                    ? users.map(otherEntity => (
                        <option value={otherEntity.id} key={otherEntity.id}>
                          {otherEntity.login}
                        </option>
                      ))
                    : null}
                </AvInput>
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/globally-free-subscription-plan" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  users: storeState.userManagement.users,
  globallyFreeSubscriptionPlanEntity: storeState.globallyFreeSubscriptionPlan.entity,
  loading: storeState.globallyFreeSubscriptionPlan.loading,
  updating: storeState.globallyFreeSubscriptionPlan.updating,
  updateSuccess: storeState.globallyFreeSubscriptionPlan.updateSuccess,
});

const mapDispatchToProps = {
  getUsers,
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(GloballyFreeSubscriptionPlanUpdate);
